/// <reference path="../_references.js" />

var mUsersControls = new UsersControls(),
    mUsersData = new UsersData();

//-----------------------
// State Manager Handlers
//-----------------------
function mStateManagerUsers_Init(aPrevious, aCurrent) {
    var lLayout = aCurrent.Tab + '.Layout.htm';

    if ((!isNullOrUndefined(aCurrent.Settings[2]) && aCurrent.Settings[2] !== 'null')) {
        mUsersData.TargetId = parseInt(aCurrent.Settings[2]);
        mStateManager.ChangeSettings(2, null);
    }

    populateElement('uMasterContentHolder', lLayout, mStateManagerUsers_OnComplete);
}

function mStateManagerUsersLayout_Init(aPrevious, aCurrent) {
    var lFilename = 'Users.' + aCurrent.Settings[0] + '.Layout.htm';
    populateElement('uUsersMainContentPanel', lFilename, mStateManagerUsersLayout_OnComplete);
}

function mStateManagerUsersPrimary_Init(aPrevious, aCurrent) {
    var lFilename = 'Users.' + aCurrent.Settings[1] + '.Layout.htm';
    populateElement('uUsersSecondaryContentPanel', lFilename, mStateManagerUsersPrimary_OnComplete);
}

function mStateManagerUsersSecondary_Init(aPrevious, aCurrent) {
    "use strict";
    if ((!isNullOrUndefined(aCurrent.Settings[2]) && aCurrent.Settings[2] !== 'null')) {
        mUsersData.TargetId = parseInt(aCurrent.Settings[2]);
        mStateManager.ChangeSettings(2, null);
        mUsersControls.CardViewFilter.filter();
    }
}

//--------------
// Load Complete
//--------------
function mStateManagerUsers_OnComplete() {
    $('#uMasterMenuPanel').show();
    //SetUsersFixedHeights();
    resetContentHolders();
    mStateManagerUsersLayout_Init(null, mStateManager.Hash());
}

function mStateManagerUsersLayout_OnComplete() {
    mStateManagerUsersPrimary_Init(null, mStateManager.Hash());
}

function mStateManagerUsersPrimary_OnComplete() {
    uUsersCardView_Init();
    uUsersCardViewFilter_Init();
    uUsersCardViewPaginator_Init();
}

//------
// Leave
//------
function mStateManagerUsers_Leave(aPrevious, aCurrent) {
    "use strict";
    if (!isNullOrUndefined(mUsersControls.CardView)) {
        mUsersControls.CardView.dispose();
        mUsersControls.CardView = null;
    }
    if (!isNullOrUndefined(mUsersControls.CardViewFilter)) {
        mUsersControls.CardViewFilter.dispose();
        mUsersControls.CardViewFilter = null;
    }
    if (!isNullOrUndefined(mUsersControls.CardViewPaginator)) {
        mUsersControls.CardViewPaginator.dispose();
        mUsersControls.CardViewPaginator = null;
    }
    if (!isNullOrUndefined(mUsersControls.ProfileValidator)) {
        mUsersControls.ProfileValidator.dispose();
        mUsersControls.ProfileValidator = null;
    }
}

//------
// Inits
//------
function uUsersCardView_Init() {
    "use strict";
    if (isNullOrUndefined(mAgentsControls.CardView)) {
        mUsersControls.CardView = new sumo.controls.CardView('uUsersCardView', 'uUsersListHolder', { 'cardTemplate': 'Interface/Users.Card.Template.htm', 'selectMethod': 'single', 'canUnselect': false, 'cssClass': 'VeritracksCardView' });
        mUsersControls.CardView.bind('selectedchanged', uUsersCardView_OnSelectChange);
        mUsersControls.CardView.bind('databind', cardView_OnDataBind);
    }
}

function uUsersCardViewFilter_Init() {
    "use strict";
    var lParams = {
        'Title': 'Find Users',
        'Content': '',
        'CssClass': 'DefaultFilter',
        'HideOnFilter': true,
        'OnFilter': uUsersCardViewFilter_OnFilter,
        'Columns': [
                { 'Id': 'Name', 'Title': 'Name', 'Type': 'Text', 'DataField': 'FullName' },
                { 'Id': 'Email', 'Title': 'Email', 'Type': 'Text', 'DataField': 'Email' }
            ],
        'Settings': null
    };

    mUsersControls.CardViewFilter = gFilterFactory.createControl(
        'uUsersCardViewFilter',
        'uUsersListFilterHolder',
        lParams);
}

function uUsersCardViewPaginator_Init() {
    "use strict";
    mUsersControls.CardViewPaginator = gPaginatorFactory.createControl('uUsersCardViewPaginator', 'uUsersPagerHolder', {
        'ItemCount': count(getDataItems('Users')),
        'ItemsPerPage': 500000
        }
    );
    mUsersControls.CardViewPaginator.bind('pagechanged', uUsersCardViewPaginator_OnPageChanged);
    mUsersControls.CardViewPaginator.trigger('pagechanged');
}

//------------
// List Events
//------------
function uUsersCardView_OnSelectChange(aSender, aId, aData) {
    mUsersData.CurrentId = aId;
    uCancelUserButton_OnClick();
    PopulateUserData();
}

function uUsersCardViewPaginator_OnPageChanged(aSender, aNewPage, aData) {
    if (isNullOrUndefined(mUsersData.Clean)) {
        mUsersData.Clean = getDataItems('Users');
    }
    if (isNullOrUndefined(mUsersData.Dirty)) {
        mUsersData.Dirty = mUsersData.Clean;
    }
    mUsersControls.CardViewFilter.filter();
}

function uUsersCardViewFilter_OnFilter(aSender, aExpression, aData) {
    var lBuilder;
    if (mUsersData.TargetId === -1) {
        mUsersData.Dirty = query(mUsersData.Clean, aExpression);
    } else {
        lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('Id', mUsersData.TargetId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        mUsersData.Dirty = query(mUsersData.Clean, lBuilder.RootExpression);
        mUsersData.TargetId = -1;
    }
    mUsersData.Paginated = mUsersControls.CardViewPaginator.paginate(mUsersData.Dirty);
    if (!isNullOrUndefined(mUsersControls.CardView)) {
        mUsersControls.CardView.setDataSource(mUsersData.Paginated);
    }
}



























function PopulateUsersGrid2(aList) {
    if (mUsersCardView === null) {
        mUsersCardView = new SumoCardView('uUsersList', 'uUsersListHolder', [
                { 'Id': 'Spacer', 'Generator': null },
                { 'Id': 'Title', 'Generator': UserTitleCellGenerator },
                { 'Id': 'Stats', 'Generator': UserStatsCellGenerator }
            ], aList, {
                'ItemsPerPage': 25,
                'OnItemSelect': uUsersCardView_OnSelectChange
            });
    }
    mUsersCardView.RenderContents(1);
}

function UsersTabContent_OnLoad() {
    mUsersData.TabsPending--;
    if (mUsersData.TabsPending === 0) {
        PopulateUsersGrid(getDataItems('Users'));
        PopulateUsersFilter();
    }
}

function UsersTabContent_Init() {
    mUsersData.TabsPending = 2;
    resetContentHolders();
//    SetUsersFixedHeights();
//    ResetUsersContentHolders((mMasterHeight - mMasterOverheadHeight));

    var lFilename = 'Users.Profile.Layout.htm';
    populateElement('uUsersMainContentPanel', lFilename, UsersTabContent_OnLoad);

    lFilename = 'Users.Permissions.Layout.htm';
    populateElement('uUsersSecondaryContentPanel', lFilename, UsersTabContent_OnLoad);
}

function GenerateNotificationCard(aNotification) {
    "use strict";
    var lTable = $('<table/>', {
        'id': 'uNotificationsList' + aNotification.Id,
        'class': 'UsersCardDetail Clickable',
        'onclick': 'uNotificationsListHolder_OnClick(this)'
    }),
    lTableRow1 = $('<tr/>', {
    }),
    lNameDiv = $("<div/>", {
        'text': aNotification.Name
    }),
    lDescriptionDiv = $("<div/>", {
        'text': aNotification.AgencyName
    }),
    lTableRow1Cell1 = $('<td/>', {
        'class': 'UsersCardSpacer',
        'rowspan': '2'
    }),
    lTableRow1Cell2 = $('<td/>', {
        'class': 'UsersCardTitle',
        'rowspan': '2'
    }),
    lTableRow1Cell3 = $('<td/>', {
        'class': 'UsersCardImage',
        'text': 'I'
    }),
    lTableRow1Cell4 = $('<td/>', {
        'class': 'UsersCardValue',
        'text': '3'
    });

    $(lNameDiv).appendTo(lTableRow1Cell2);
    $(lDescriptionDiv).appendTo(lTableRow1Cell2);
    $(lTableRow1Cell1).appendTo(lTableRow1);
    $(lTableRow1Cell2).appendTo(lTableRow1);
    $(lTableRow1Cell3).appendTo(lTableRow1);
    $(lTableRow1Cell4).appendTo(lTableRow1);
    $(lTableRow1).appendTo(lTable);

    return lTable;
}

function PopulateUserList(aList) {
    "use strict";
    var i,
        lHolder = document.getElementById('uUsersListHolder');
    lHolder.innerHTML = "";
    for (i = 0; i < aList.length; i++) {
        var lCard = GenerateUserCard(aList[i]);
        $(lCard).appendTo(lHolder);
    }
}

function PopulateNotificationList(aList) {
    "use strict";
    var i,
        lHolder = document.getElementById('uAgentsListHolder');
    lHolder.innerHTML = "";
    for (i = 0; i < aList.length; i++) {
        var lCard = GenerateNotificationCard(aList[i]);
        $(lCard).appendTo(lHolder);
    }
}

function PopulateUsersTabContent() {
    "use strict";
    var lFilename = '';
    switch (mCurrentHash.Settings[0]) {
        case 'Users':
           setHeight('#uUsersMainContentPanel', ($('#uUsersMainContentPanel').height() / 2));
            $('#uUsersSecondaryContentHolder').show('fast', function () {
                resetContentHolders();
                //                SetUsersFixedHeights();
                //                ResetUsersContentHolders((mMasterHeight - mMasterOverheadHeight));
            });
            //setWidth('#uUsersListCell', mUsersListWidth);
            $('#uUsersListHolder').show('fast', function () {
                $('#uUsersListFilter').show('fast', function () {
                    resetContentHolders();
                    //                    SetUsersFixedHeights();
                    //                    ResetUsersContentHolders((mMasterHeight - mMasterOverheadHeight));
                });
            });
            lFilename = 'Users.' + mCurrentHash.Settings[0] + '.' + mCurrentHash.Settings[1] + '.Layout.htm';
            populateElement('uUsersSecondaryContentPanel', lFilename);
            PopulateUserList(mUserSummary);
            break;
        case 'NotificationEscalationPlans':
            $('#uUsersSecondaryContentHolder').hide('fast', function () {
                resetContentHolders();
                //                SetUsersFixedHeights();
                //                ResetUsersContentHolders((mMasterHeight - mMasterOverheadHeight));
            });
            //setWidth('#uUsersListCell', mUsersListWidth);
            $('#uUsersListHolder').show('fast', function () {
                $('#uUsersListFilter').show('fast', function () {
                    resetContentHolders();
                    //                    SetUsersFixedHeights();
                    //                    ResetUsersContentHolders((mMasterHeight - mMasterOverheadHeight));
                });
            });
            PopulateNotificationList(mEscalationPlans);
            break;
        case 'DefaultNotifications':
            $('#uUsersSecondaryContentHolder').hide('fast', function () {
                resetContentHolders();
                //                SetUsersFixedHeights();
                //                ResetUsersContentHolders((mMasterHeight - mMasterOverheadHeight));
            });
            $('#uUsersListHolder').hide('fast', function () {
                $('#uUsersListFilter').hide('fast', function () {
                    //setWidth('#uUsersListCell', 0);
                    resetContentHolders();
                    //                    SetUsersFixedHeights();
                    //                    ResetUsersContentHolders((mMasterHeight - mMasterOverheadHeight));
                });
            });
            break;
    }
    lFilename = 'Users.' + mCurrentHash.Settings[0] + '.Layout.htm';
    populateElement('uUsersMainContentPanel', lFilename);
}

function PopulateUserSecurityQuestionsDropdown(aBaseElementId) {
    var lBaseElement = $('#' + aBaseElementId),
        lSelect = $('<select/>', {
            'id': 'uSecurityQuestionSelect'
        }),
        lListItem,
        i;

    for (i = 0; i < 10; i++) {
        lListItem = $('<option/>', {
            'text': 'question ' + i,
            'value': i
        });
        lListItem.appendTo(lSelect);
    }
    lBaseElement.html('');
    lSelect.appendTo(lBaseElement);
}

function PopulateUserData() {
    "use strict";
    var lUser = GetUser(mUsersData.CurrentId),
        lPasswordStrength = 'weak';
    if (lUser != null) {
        // Agent
        PopulateDetailView(lUser, {}, 'uUserProfile');
//        document.getElementById('uFirstName').innerHTML = lUser.FirstName;
//        document.getElementById('uLastName').innerHTML = lUser.LastName;
//        document.getElementById('uAgencies').innerHTML = lUser.AgencyName;
//        document.getElementById('uEmail').innerHTML = lUser.Email;
//        document.getElementById('uCellPhone').innerHTML = lUser.CellPhone;
//        document.getElementById('uWorkPhone').innerHTML = lUser.WorkPhone;
//        document.getElementById('uHomePhone').innerHTML = lUser.HomePhone;
//        document.getElementById('uTimeZone').innerHTML = lUser.TimeZone;

        // User
//        document.getElementById('uUserName').innerHTML = lUser.UserName;
//        switch (lUser.PasswordStrength) {
//            case 2:
//                lPasswordStrength = "medium";
//                break;
//            case 3:
//                lPasswordStrength = "strong";
//                break;
//        }
//        document.getElementById('uPassword').innerHTML = '[' + lPasswordStrength + ']';
//        document.getElementById('uSecurityQuestion').innerHTML = SecurityQuestionFormatter(lUser.SecurityQuestionId);
//        document.getElementById('uSecurityAnswer').innerHTML = '******';
//        document.getElementById('uPhoneSupportId').innerHTML = lUser.PhoneSupportId;
//        document.getElementById('uPhoneSupportPin').innerHTML = '******';
    }
}

function PopulateUserEditData() {
    "use strict";
    var lUser = GetUser(mUsersData.EditingId);
    if (lUser != null) {
        populateEditView(lUser, [
            { 'Id': 'SecurityQuestionId', 'Type': 'Dropdown', 'DataSource': getDataItems('SecurityQuestions'), 'DataValueField': 'Id', 'DataTextField': 'Value' }
        ], {}, 'uUserProfile', 'Edit');
        //$("#uUserProfileForm")
        //PopulateUserSecurityQuestionsDropdown('uSecurityQuestionHolder');
        // Agent
        //document.getElementById('uFirstNameText').value = lUser.FirstName;
        //document.getElementById('uLastNameText').value = lUser.LastName;
        //document.getElementById('uEmailText').value = lUser.Email;
        //document.getElementById('uCellPhoneText').value = lUser.CellPhone;
//        document.getElementById('uWorkPhoneText').value = lUser.WorkPhone;
//        document.getElementById('uHomePhoneText').value = lUser.HomePhone;
//        document.getElementById('uTimeZoneText').value = lUser.TimeZone;

        // User
        //document.getElementById('uUserNameText').value = lUser.UserName;
        //document.getElementById('uPasswordText').value = '';
        //$('#uSecurityQuestionSelect').val(lUser.SecurityQuestionId);
        //document.getElementById('uSecurityAnswerText').value = '';
        //        document.getElementById('uPhoneSupportPinText').value = '';
        mUsersControls.ProfileValidator = new Validator('uUserProfilePanel', mRegexValidation);
    }
}

function ClearUserEditData() {
    "use strict";
    // Agent
    document.getElementById('uFirstNameText').value = 'New User';
    document.getElementById('uLastNameText').value = '';
    document.getElementById('uEmailText').value = '';
    document.getElementById('uCellPhoneText').value = '';
//    document.getElementById('uWorkPhoneText').value = '';
//    document.getElementById('uHomePhoneText').value = '';
//    document.getElementById('uTimeZoneText').value = '';

    // User
    document.getElementById('uUserNameText').value = '';
    document.getElementById('uPasswordText').value = '';
//    document.getElementById('uUserNameText').value = '';
//    document.getElementById('uPasswordText').value = '';
//    document.getElementById('uSecurityQuestionText').value = '';
//    document.getElementById('uSecurityAnswerText').value = '';
    //    document.getElementById('uPhoneSupportPinText').value = '';
}

function SaveUser_OnComplete(aParams, aUser) {
    var l = '';
}

function SaveUser() {
    var lUser,
        lIsNewUser = false,
        lPassword = document.getElementById('uPasswordText').value,
        lSecurityAnswer = document.getElementById('uSecurityAnswerText').value,
        lSupportPin = document.getElementById('uPhoneSupportPinText').value;
    if (mUsersData.EditingId !== -1) {
        lUser = GetUser(mUsersData.EditingId);
    } else {
        lUser = new User();
        lIsNewUser = true;
    }
    lUser.FirstName = document.getElementById('uFirstNameText').value;
    lUser.LastName = document.getElementById('uLastNameText').value;
    lUser.Email = document.getElementById('uEmailText').value;
    lUser.PrimaryPhone = document.getElementById('uCellPhoneText').value;
    lUser.UserName = document.getElementById('uUserNameText').value;
    lUser.TransactionId = moment().format("YYYYMMDDHHmmss");

    if (lIsNewUser || lPassword !== '') {
        lUser.Password = lPassword;
    }
    if (lIsNewUser || lSecurityAnswer !== '') {
        lUser.SecurityQuestionId = $('#uSecurityQuestionSelect').val();
        lUser.SecurityAnswer = lSecurityAnswer;
    } 
    if (lIsNewUser || lSupportPin !== '') {
//        lUser.UserName = document.getElementById('uUserNameText').value;
    }

    WriteSingle(lUser, SaveUser_OnComplete, Sad, null)
}

function SelectUser(aUserId) {
    "use strict";
    mUsersData.CurrentId = aUserId;
    $('.UsersCardDetail.Selected').removeClass('Selected');
    $('#uUsersList' + aUserId).addClass('Selected');

    PopulateUserData(aUserId);
}

//function SelectNotification(aNotificationId) {
//    "use strict";
//    mCurrentNotificationId = aNotificationId;
//    $('.UsersCardDetail.Selected').removeClass('Selected');
//    $('#uNotificationsList' + aNotificationId).addClass('Selected');

//    //PopulateUserData(aNotificationId);
//}


// EVENTS

function uEditUserButton_OnClick() {
    "use strict";
    $('#uEditUserButton').hide();
    $('#uAddUserButton').hide();

    $('#uSaveUserButton').show();
    $('#uCancelUserButton').show();

    mUsersData.EditingId = mUsersData.CurrentId;
    PopulateUserEditData();
    EnterEditMode('uUserProfilePanel');
}

function uAddUserButton_OnClick() {
    "use strict";
    $('#uEditUserButton').hide();
    $('#uAddUserButton').hide();

    $('#uSaveUserButton').show();
    $('#uCancelUserButton').show();

    mUsersData.EditingId = -1;
    ClearUserEditData();
    EnterEditMode('uUserProfilePanel');
}

function uSaveUserButton_OnClick() {
    "use strict";
    if (mUsersControls.ProfileValidator.IsValid()) {
        $('#uEditUserButton').show();
        $('#uAddUserButton').show();

        $('#uSaveUserButton').hide();
        $('#uCancelUserButton').hide();

        SaveUser();
        ClearValidation();
        ExitEditMode('uUserProfilePanel');
    }
}

function uCancelUserButton_OnClick() {
    "use strict";
    $('#uEditUserButton').show();
    $('#uAddUserButton').show();

    $('#uSaveUserButton').hide();
    $('#uCancelUserButton').hide();

    ClearValidation();
    ExitEditMode('uUserProfilePanel');
}

function uUsersListHolder_OnClick(aSender) {
    "use strict";

    uCancelAgentButton_OnClick();
    SelectUser(aSender.id.substring(10, aSender.id.length));
}

//function uNotificationsListHolder_OnClick(aSender) {
//    "use strict";

//    //uCancelAgentButton_OnClick();
//    SelectNotification(aSender.id.substring(18, aSender.id.length));
//}

// FORMATTERS
function UserNameFormatter(aId) {
    /**
    var lName = 'Unknown',
        lObject = getDataItem(aId, 'Users');

    if (!isNullOrUndefined(lObject)) {
        lName = lObject.FullName;
    } else if (isNullOrUndefined(lObject)) {
        lObject = getDataItem(aId, 'AgentsStop');
        if (!isNullOrUndefined(lObject)) {
            lName = lObject.FullName;
        }
    }
    **/

    return UserNameTagFormatter(aId);
}

function UserNameTagFormatter(aId) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    var lName = 'Unknown',
    lObject = getDataItem(aId, 'Users');

    if (!isNullOrUndefined(lObject)) {
        lName = lObject.FullName;
    } else if (isNullOrUndefined(lObject)) {
        lBuilder.AddNewExpressionConditional('UserId', aId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lObject = query(getDataItems('AgentsStop'), lBuilder.RootExpression)
        if (!isNullOrUndefined(lObject)) {
            if (lObject.length >= 1) {
                lName = lObject[Object.keys(lObject)[0]].FullName;
            } else {
                lName = 'Unknown';
            }

        }
    }
    

    return lName; 

    
}

function SecurityQuestionFormatter(aSecurityQuestionId) {
    var lReturn = 'Unknown',
        lQuestion = getDataItem(aSecurityQuestionId, 'SecurityQuestions');

    if (lQuestion != null) {
        lReturn = lQuestion.Value;
    }

    return lReturn;
}

function userPasswordStrengthFormatter(aPasswordStrength) {
    var lPasswordStrength = 'weak';
    switch (aPasswordStrength) {
        case 2:
            lPasswordStrength = "medium";
            break;
        case 3:
            lPasswordStrength = "strong";
            break;
    }
    return lPasswordStrength;
}

// GENERATORS
function UserTitleCellGenerator(aUser) {
    var lMasterDiv = $('<div/>', {}).attr('RowId', aUser.Id),
        lNameDiv = $("<div/>", {
            'text': aUser.FirstName + ' ' + aUser.LastName
        }).attr('RowId', aUser.Id);

    lNameDiv.appendTo(lMasterDiv);

    return lMasterDiv;
}

function UserStatsCellGenerator(aUser) {
    var lOffHoursImage = 'Images/EventLevel0Dark16.png',
        lClockedOnImage = 'Images/EventLevel0Dark16.png';

    var lMasterDiv = $('<div/>', {}).attr('RowId', aUser.Id),
    lOffHoursDiv = $('<div/>', {}).attr('RowId', aUser.Id),
    lClockedOnDiv = $('<div/>', {}).attr('RowId', aUser.Id),
    lClock = $('<img/>', {
        'alt': 'Off Hours',
        'title': 'Off Hours',
        'src': 'Images/ClockDark16.png'
    }).attr('RowId', aUser.Id),
    lOffHours = $('<img/>', {
        'alt': 'Off Hours',
        'title': 'Off Hours',
        'src': lOffHoursImage
    }).attr('RowId', aUser.Id),
    lUser = $('<img/>', {
        'alt': 'Clocked On',
        'title': 'Clocked On',
        'src': 'Images/AgentsDark16.png'
    }).attr('RowId', aUser.Id),
    lClockedOn = $('<img/>', {
        'alt': 'Clocked On',
        'title': 'Clocked On',
        'src': lClockedOnImage
    }).attr('RowId', aUser.Id);

    lOffHours.appendTo(lOffHoursDiv);
    lClock.appendTo(lOffHoursDiv);
    lClockedOn.appendTo(lClockedOnDiv);
    lUser.appendTo(lClockedOnDiv);
    lOffHoursDiv.appendTo(lMasterDiv);
    lClockedOnDiv.appendTo(lMasterDiv);

    return lMasterDiv;
}

function UserUniversalSearchGenerator(aDataItem) {
    return aDataItem.FullName + ' (' + aDataItem.Email + ', ' + aDataItem.UserName + ')';
}


//------------
// Data Access
//------------

function GetUser(aUserId) {
    var lResult = null,
        lUser;

    if (!isNullOrUndefined(getDataItems('Users'))) {
        lUser = getDataItem(aUserId, 'Users');
    }

    if (!isNullOrUndefined(lUser)) {
        lResult = lUser;
    }

    return lResult;
}

function hideScoreCard(aClass) {
    "use strict";
    for (var i = 0; i <= 4; i++) {
        $('.' + aClass + ' .ScoreCard' + i).removeClass('Reached');
        $('.' + aClass + ' .scoreText' + i).hide();
    }
}

function showScoreCard(aClass, score) {
    "use strict";
    hideScoreCard(aClass);
    $('.' + aClass + ' .ScoreCard' + score).addClass('Reached');
    $('.' + aClass + ' .scoreText' + score).show();
    if (score == 0) {
        $('.' + aClass + ' .ScoreCard1').addClass('Reached');
        $('.' + aClass + ' .scoreText1').show();
        return;
    }
    while (score > 0) {
        score = score - 1;
        $('.' + aClass + ' .ScoreCard' + score).addClass('Reached');
    }
}
function getPasswordStrength(aPassword, aUser) {
    if (aUser) {
        if (!aUser.PasswordPolicy) {
            return 4;
        } else {
            return customPasswordStrength(aPassword);
        }
    } else {
        if (!gUserDetails.PasswordPolicy) {
            return 4;
        } else {
            return customPasswordStrength(aPassword);
        }
    }
   
}

function zxcvbnPasswordStrength(aPassword) {
    var lScore = zxcvbn(aPassword, ["stopllc", "veritracks"]).score;

    if (aPassword == "") {
        lScore = -1;
    }
    return lScore;
}

function customPasswordStrength(aPassword) {
    "use strict";
    var lScore = 0;
    if (aPassword.length >= 8) {
        var regex = /^(?=.*[a-z]).+$/;
        var regex2 = /^(?=.*[A-Z]).+$/;

        if (regex.test(aPassword) && regex2.test(aPassword)) {
            lScore++;
        }
        var regex = /^(?=.*[0-9]).+$/;

        if (regex.test(aPassword)) {
            lScore++;
        }
        var regex = /^(?=.*[!@#\$%\^\&*\)\(+=._-]).+$/;

        if (regex.test(aPassword)) {
            lScore++;
        }

        if (aPassword.length >= 10 && lScore == 3) {
            lScore++;
        }
        if (lScore == 4) {
            console.log(zxcvbnPasswordStrength(aPassword));
        }
    }
    if (aPassword == "") {
        lScore = -1;
    }

    return lScore;
}

function UserPopupPassword() {
    "use strict";
    var lHtml = [];
    if (gUserDetails.PasswordPolicy) {
        lHtml.push('<tr class="MyAccountSettings">');
        lHtml.push('<div>')
        lHtml.push('<p>' + localizeWrapper('cAgentWhatIsStrongPassword') + '</p>');
        lHtml.push('</div>')
        lHtml.push('</tr>');
    }
    lHtml.push('<tr class="MyAccountSettings">');
    lHtml.push('<div id="uAgentPasswordDuplicateError" style="display:none;margin-left:8px;" class="Alert">' + localizeWrapper('cAgentPasswordDuplicateError') + '</div>');
    lHtml.push('</tr>');
    lHtml.push('<tr class="MyAccountSettings">');
    lHtml.push('<div id="uAgentPasswordWeakError" style="display:none;margin-left:8px;" class="Alert">' + localizeWrapper('cAgentPasswordWeakError') + '</div>');
    lHtml.push('</tr>');
    lHtml.push('<tr class="MyAccountSettings">');
    lHtml.push('<td class="FormTitle">' + localizeWrapper('cAgentNewPassword') + '</td>');
    lHtml.push('<td><input type="password" id="uUserDetailsPasswordEdit" class="Validate ValidatePassword ValidateRequired  ValidateLength Validate20Length" /></td>');
    lHtml.push('</tr>');
    lHtml.push('<tr class="MyAccountSettings">');
    lHtml.push('<td class="FormTitle">' + localizeWrapper('cAgentConfirmPassword') + '</td>');
    lHtml.push('<td><input type="password" id="uUserDetailsPasswordConfirmEdit" class="Validate ValidateNotNull  ValidatePasswordMatch ValidateRequired" /></td>');
    lHtml.push('</tr>');
    if (gUserDetails.PasswordPolicy) {
        lHtml.push('<tr><td colspan="3" id="uPasswordHolder"><table class="AgentUpdatePassword ScoreCard"><tr>');
        lHtml.push('<td class="ScoreCard1" valign="top"><hr /><span class="scoreText1">no</span></td>');
        lHtml.push('<td class="ScoreCard2" valign="top"><hr /><span class="scoreText2">almost</span></td>');
        lHtml.push('<td class="ScoreCard3" valign="top"><hr /><span class="scoreText3">nice</span></td>');
        lHtml.push('<td class="ScoreCard4" valign="top"><hr /><span class="scoreText4">excellent!</span></td>');
        lHtml.push('</tr></table></td></tr>');
    }
    return lHtml.join('');
}

function UserPopupSecurityQuestion() {
    "use strict";
    var lHtml = [];

    lHtml.push('<tr class="MyAccountSettings">');
    lHtml.push('<td class="FormTitle">' + localizeWrapper('cAgentSecurityQuestion') + '</td>');
    lHtml.push('<td><select id="uUserDetailsSecurityQuestionIdEdit" class="Validate ValidateRequired"></select></td>');
    lHtml.push('</tr>');
    lHtml.push('<tr class="MyAccountSettings">');
    lHtml.push('<td class="FormTitle">' + localizeWrapper('cAgentSecurityAnswer') + '</td>');
    lHtml.push('<td><input type="text" id="uUserDetailsSecurityAnswerEdit" class="Validate ValidateRequired" /></td>');
    lHtml.push('</tr>');
    return lHtml.join('');
}

function UserPopupSecurityAnswer() {
    "use strict";
    var lHtml = [];
    lHtml.push('<tr class="MyAccountSettings">');
    lHtml.push('<td colspan="3"><div id="uAgentSecurityAnswerError" style="display:none;margin-left:8px;" class="Alert">' + localizeWrapper('cAgentSecurityAnswerError') + '</div></td>');
    lHtml.push('</tr>');
    lHtml.push('<tr class="MyAccountSettings">');
    lHtml.push('<td class="FormTitle">' + localizeWrapper('cAgentSecurityQuestion') + '</td>');
    lHtml.push('<td><span id="uUserDetailsSecurityQuestion"></span></td>');
    lHtml.push('</tr>');
    lHtml.push('<tr class="MyAccountSettings">');
    lHtml.push('<td class="FormTitle">' + localizeWrapper('cAgentSecurityAnswer') + '</td>');
    lHtml.push('<td><input type="text" id="uUserDetailsSecurityAnswerEdit" class="Validate ValidateRequired" /></td>');
    lHtml.push('</tr>');
    return lHtml.join('');
}


function NewUserPopup() {
    var lBuilder = new SumoPredicateBuilder();
    var lButtonBar = GenerateButtonCommandBar();
    var lHtml = [];

    ReadMultiple(gObjectList.SecurityQuestion.AssemblyQualifiedName, null, 0, securityQuestionRead_OnSuccess, null, null, null, 0, false);
    lBuilder.AddNewExpressionConditional('Id', gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.User.AssemblyQualifiedName, lBuilder.RootExpression, 0, credentialsUserRead_OnSuccess, null, null, null, 0, false);

    lHtml.push('<table id="uUserCredentialsPanel">');
    lHtml.push('<tr>');
    lHtml.push('<div>')
    lHtml.push('<p>' + localizeWrapper('cAgentVeritracksWelcomeInfo') + '</p>');
    lHtml.push('</div>')
    lHtml.push('</tr>');
    lHtml.push(UserPopupPassword());
    lHtml.push(UserPopupSecurityQuestion());
    lHtml.push('</table>');

    GenerateButton(localizeWrapper('cEnrolleeSave'), 'Hidden Save', UserCredentialsSaveButton_OnClick).appendTo(lButtonBar);
    DisplayPopup(localizeWrapper('cAgentVeritracksWelcome'), lHtml.join(''), lButtonBar, true);
    mValidator = new Validator('uUserCredentialsPanel', mRegexValidation);

    hideScoreCard('AgentUpdatePassword');
}

function ResetUserPopup() {
    var lBuilder = new SumoPredicateBuilder();
    var lButtonBar = GenerateButtonCommandBar();
    var lHtml = [];

    lBuilder.AddNewExpressionConditional('Id', gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.User.AssemblyQualifiedName, lBuilder.RootExpression, 0, credentialsUserRead_OnSuccess, null, null, null, 0, false);

    lHtml.push('<table id="uUserCredentialsPanel">');
    lHtml.push('<tr>');
    lHtml.push('<div>')
    lHtml.push('<p>' + localizeWrapper('cAgentVeritracksResetInfo') + '</p>');
    lHtml.push('</div>')
    lHtml.push('</tr>');
    lHtml.push(UserPopupPassword());
    lHtml.push('</table>');

    GenerateButton(localizeWrapper('cEnrolleeSave'), 'Hidden Save', UserResetCredentialsSaveButton_OnClick).appendTo(lButtonBar);
    DisplayPopup(localizeWrapper('cAgentVeritracksReset'), lHtml.join(''), lButtonBar, true);
    mValidator = new Validator('uUserCredentialsPanel', mRegexValidation);

    hideScoreCard('AgentUpdatePassword');
}

function InactiveExpiredUserPopup(Type) {
    var lBuilder = new SumoPredicateBuilder();
    var lButtonBar = GenerateButtonCommandBar();
    var lHtml = [];

    lBuilder.AddNewExpressionConditional('Id', gUserDetails.SecurityQuestionId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And())
    ReadMultiple(gObjectList.SecurityQuestion.AssemblyQualifiedName, lBuilder.RootExpression, 0, securityQuestionInactiveUserRead_OnSuccess, null, null, null, 0, false);
    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('Id', gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.User.AssemblyQualifiedName, lBuilder.RootExpression, 0, credentialsUserRead_OnSuccess, null, null, null, 0, false);



    lHtml.push('<table id="uUserCredentialsPanel">');
    lHtml.push('<tr>');
    lHtml.push('<div>')
    lHtml.push('<p>' + localizeWrapper('cAgentVeritracks' + Type + 'Info') + '</p>');
    lHtml.push('</div>')
    lHtml.push('</tr>');
    lHtml.push(UserPopupSecurityAnswer());
    lHtml.push(UserPopupPassword());
    lHtml.push('</table>');

    GenerateButton(localizeWrapper('cEnrolleeSave'), 'Hidden Save', UserInactiveCredentialsSaveButton_OnClick).appendTo(lButtonBar);
    DisplayPopup(localizeWrapper('cAgentVeritracks' + Type), lHtml.join(''), lButtonBar, true);
    mValidator = new Validator('uUserCredentialsPanel', mRegexValidation);

    hideScoreCard('AgentUpdatePassword');

    function securityQuestionInactiveUserRead_OnSuccess(aParams, aData) {
        var lQuestion = aData[0];

        if (lQuestion) {
            $('#uUserDetailsSecurityQuestion').text(lQuestion.Value);
        }
    }
}

function securityQuestionRead_OnSuccess(aParams, aData) {
    populateEditView('', [
   { 'Id': 'SecurityQuestionId', 'Type': 'Dropdown', 'DataSource': aData, 'DataValueField': 'Id', 'DataTextField': 'Value', 'isNullableKey': true, 'nullValue': '' }
    ], {}, 'uUserDetails', 'Edit');
    $('uUserDetailsSecurityQuestionIdEdit').change();

    if (gUserDetails.AccountStatus != "NEW" && gUserDetails.SecurityQuestionId !== -1) {
        $("#uUserDetailsSecurityQuestionIdEdit").val(gUserDetails.SecurityQuestionId.toString());
        $("#uUserDetailsSecurityQuestionIdEdit").prop('disabled', true);
    }
}

function UserCredentialsPasswordResetSave_OnSuccess(aParams, aData) {
    var lUserEditItem;

    if (aData == -2) {
        $('#uAgentPasswordDuplicateError').show();
        mActivityNotification.addNotification(localizeWrapper('cAgentPasswordDuplicateError'));
    } else {
        mActivityNotification.addNotification(localizeWrapper('cAgentPasswordUpdated'));
        mValidator.dispose();
        ClosePopup();
        systemDisplay_Init();
    }
}

function UserCredentialsPasswordInactiveSave_OnSuccess(aParams, aData) {
    var lUserEditItem;

    if (aData == -1) {
        $('#uAgentSecurityAnswerError').show();
        mActivityNotification.addNotification(localizeWrapper('cAgentSecurityAnswerError'));
        return;
    }
    else if (aData == -2) {
        $('#uAgentPasswordDuplicateError').show();
        mActivityNotification.addNotification(localizeWrapper('cAgentPasswordDuplicateError'));

    } else {
        mActivityNotification.addNotification(localizeWrapper('cAgentPasswordUpdated'));
        mValidator.dispose();
        ClosePopup();
        systemDisplay_Init();
    }
}
function UserCredentialsPasswordSave_OnSuccess(aParams, aData) {
    var lSecurityAnswer = $('#uUserDetailsSecurityAnswerEdit').val(),
        lQuestion = $('#uUserDetailsSecurityQuestionIdEdit').val(),
        lUserSecurityAnswer,
        lUserEditItem,
        lUser = getDataItems('UserDetails');

    if (aData == -2) {
        $('#uAgentPasswordDuplicateError').show();
        mActivityNotification.addNotification(localizeWrapper('cAgentPasswordDuplicateError'));
    }
    else if (mValidator.IsValid() && aData == 1) {
        $('#uPasswordChangeErrorContainer').fadeOut("fast");
        if (typeof lQuestion != 'undefined') {
            lUserEditItem = lUser[0];
            lUserEditItem.SecurityQuestionId = lQuestion;
            WriteSingle(lUserEditItem, SecuirtyAnswerRead_OnSuccess, null, lQuestion, true);
        } else {
            lUserEditItem = lUser[0];
            WriteSingle(lUserEditItem, SecuirtyAnswerRead_OnSuccess, null, lQuestion, true);
        }

    } else {
        $('#uPasswordChangeErrorContainer').fadeIn("fast");
    }

}//end of function

function SecuirtyAnswerRead_OnSuccess(aParams, aData) {
    "use strict";
    var lSecurityAnswer = $('#uUserDetailsSecurityAnswerEdit').val();

    if (typeof lSecurityAnswer != 'undefined') {
        var lUserSecurityAnswer = new UserSecurityAnswer();
        lUserSecurityAnswer.UserId = gUserDetails.UserId;
        lUserSecurityAnswer.SecurityQuestionId = aParams;
        lUserSecurityAnswer.SecurityAnswer = lSecurityAnswer;
        WriteSingle(lUserSecurityAnswer, credentialsUserWrite_OnSuccess, null, null, true);
        gUserDetails.SecurityQuestionId = aParams;
        UpdateUserDetails(); //10/17/2016 -EE
    } else {
        credentialsUserWrite_OnSuccess();
    }//end of if
}//end of function

function UpdateUserDetails() {
    var lToken = veritracks.security.controller.tryGetSecurityToken();
    callAjax('UpdateUserDetails', {
        'aSecurityToken': lToken,
        'aSecurityContextId': 1,
        'aUserDetails': gUserDetails
    });
}

function UserCredentialsSecurityAnswerSave_OnSuccess(aParams, aData) {
}

function credentialsUserRead_OnSuccess(aParams, aData) {
    mCache.AddExpirableItem(aData, 'UserDetails', 60 * 15, false, null);
    $('#uPopupContainer .SaveButton').removeClass('Hidden');
}

function credentialsUserWrite_OnSuccess(aParams, aData) {
    mActivityNotification.addNotification(localizeWrapper('cAgentPasswordInformationSet'));
    mValidator.dispose();
    ClosePopup();
    systemDisplay_Init();
}

function UserResetCredentialsSaveButton_OnClick() {
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (mValidator.IsValid()) {
        var lNewPassword = $('#uUserDetailsPasswordEdit').val(),
            lSecurityAnswer = $('#uUserDetailsSecurityAnswerEdit').val(),
            lSecurityQuestionId = $("#uUserDetailsSecurityQuestionIdEdit").val();

        var lStrength = getPasswordStrength(lNewPassword);
        $('#uAgentPasswordDuplicateError').hide();
        $('#uAgentPasswordWeakError').hide();
        if (lStrength <= 2) {
            $('#uAgentPasswordWeakError').show();
            mActivityNotification.addNotification('Password not strong enough');
            return;
        }
        callAjax('UpdatePassword',
     { 'aSecurityToken': lSecurityToken, 'aPassword': lNewPassword },
     UserCredentialsPasswordResetSave_OnSuccess,
      userDetailsData_OnFailure,
      lNewPassword);


    }
}

function UserInactiveCredentialsSaveButton_OnClick() {
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (mValidator.IsValid()) {
        var lNewPassword = $('#uUserDetailsPasswordEdit').val(),
            lSecurityAnswer = $('#uUserDetailsSecurityAnswerEdit').val(),
            lSecurityQuestionId = gUserDetails.SecurityQuestionId;

        var lStrength = getPasswordStrength(lNewPassword);
        $('#uAgentPasswordDuplicateError').hide();
        $('#uAgentPasswordWeakError').hide();
        $('#uAgentSecurityAnswerError').hide();
        if (lStrength <= 2) {
            $('#uAgentPasswordWeakError').show();
            mActivityNotification.addNotification('Password not strong enough');
            return;
        }
        callAjax('UpdateExpiredPassword',
     {
         'aSecurityToken': lSecurityToken,
         'aUserId': gUserDetails.UserId,
         'aSecurityQuestionId': lSecurityQuestionId,
         'aSecurityAnswer': lSecurityAnswer,
         'aPassword': lNewPassword
     },
     UserCredentialsPasswordInactiveSave_OnSuccess,
      userDetailsData_OnFailure,
      lNewPassword);


    }
}

function UserCredentialsSaveButton_OnClick() {
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (mValidator.IsValid()) {
        var lNewPassword = $('#uUserDetailsPasswordEdit').val(),
            lSecurityAnswer = $('#uUserDetailsSecurityAnswerEdit').val(),
            lSecurityQuestionId = $("#uUserDetailsSecurityQuestionIdEdit").val();

        var lStrength = getPasswordStrength(lNewPassword);
        $('#uAgentPasswordDuplicateError').hide();
        $('#uAgentPasswordWeakError').hide();
        if (lStrength <= 2) {
            $('#uAgentPasswordWeakError').show();
            mActivityNotification.addNotification('Password not strong enough');
            return;
        }
        callAjax('UpdatePassword',
     { 'aSecurityToken': lSecurityToken, 'aPassword': lNewPassword },
     UserCredentialsPasswordSave_OnSuccess,
      userDetailsData_OnFailure,
      lNewPassword);


    }
}

function AccountExpiryCheck() {
    "use strict";
    var lExpireDays = veritracks.system.clientSetting('passwordexpirationdays');
    var lLastUpdated = moment(gUserDetails.PasswordLastUpdated);
    var lExpireDate = lLastUpdated.add(lExpireDays, 'days');
    var lDifference = lExpireDate.diff(moment(), 'days')

    if (gUserDetails.PasswordPolicy == 0) {
        return;
    }
    if (lDifference <= 7) {
        if (lDifference == 1) {
            $('#UserAccountExpired').text(localizeText('cPasswordExpireDaysRemaining') + ' ' + lDifference + ' ' + localizeText('cDay'));
        } else if (lDifference == 0) {
            $('#UserAccountExpired').text(localizeText('cPasswordExpireDayToday'));
        } else if (lDifference < 0) {
            $('#UserAccountExpired').text(localizeText('cPasswordExpiredNotice'));
        } else {
            $('#UserAccountExpired').text(localizeText('cPasswordExpireDaysRemaining') + ' ' + lDifference + ' ' + localizeText('cDays'));
        }
        $('#UserAccountExpired').show();
    }
}

function FadeOutAccountExpire() {
    $('#UserAccountExpired').fadeOut();
}